import React from 'react';
import { Backdrop } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

export interface LoadingIndicatorI {
  loading: boolean;
}

export default function LoadingIndicator(props: LoadingIndicatorI) {
  if (!props.loading) {
    return <div></div>;
  }
  return (
    <div>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 2 }}
        open={true}
      >
        <CircularProgress color='inherit' />
      </Backdrop>
    </div>
  );
}
